import axios from "axios";
import { authHeaderFile, authHeaderJson } from "../auth-header.service";
import moment from "moment";
import { isNullUndefinedOrEmpty } from "../../common/Helpers";
import { requestExportToken } from "../export.service";

const getBoardById = (boardId, getNew) => {
    return axios.get(`/api/Board/board/${boardId}`, { headers: authHeaderJson() })
};

const getBoardStructure = (boardId, getNew) => {
    return axios.get(`/api/Board/board/${boardId}/list?getNew=${getNew}`, { headers: authHeaderJson() })
};

const getBoardStructureGeneric = (boardTypeId, elementId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Board/boardgeneric/${boardTypeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/list`, { headers: authHeaderJson() })
};

const getElementsByBoardId = (boardId) => {
    return axios.get(`/api/Board/boardelement/${boardId}/list`, { headers: authHeaderJson() } );
};

const getBoardElementDataseries = (boardId, elementId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Board/boardelementdataseries/${boardId}/${elementId}/list`, { headers: authHeaderJson() } );
};

const getBoardElementRoles = (boardId, elementId) => {
    //[##DEPRECATED##]
    return axios.get(`/api/Board/boardelementroles/${boardId}/list?element_id=${elementId}`, { headers: authHeaderJson() } );
};

const getBoardConsolidations = (boardId) => {
    //return axios.get(`/api/Board/boardconsolidations/${boardId}/list`, { headers: authHeaderJson() } );
    return {
        data: { data: 
            [
                {id: 1, name: "nombre 1", code: "code 1", ketyword: "C", asocciatedValue: 2},
                {id: 2, name: "nombre 2", code: "code 2", ketyword: "C", asocciatedValue: 4},
                {id: 3, name: "nombre 3", code: "code 3", ketyword: "C", asocciatedValue: 6},
                {id: 4, name: "nombre 4", code: "code 4", ketyword: "C", asocciatedValue: 8},
            ],
            succeeded: true
        }
    }
};

const getHomeBoardStadistic = (calendarSelectorId, periodId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkHome/boardHome/kpi/${calendarSelectorId}/${periodId}`, { headers: authHeaderJson() })    
};

const getHomeBoardKpiGraph = () => {
    return axios.get(`/api/SkHome/boardHome/kpigraph`, { headers: authHeaderJson() })    
};

const getElements = (appelementId) => {
    return axios.get(`/api/Board/elements/${appelementId}/list`, { headers: authHeaderJson() })    
};

const getBoardElementDataserieValue = (dataserieId, dataserieValueId, serieTime) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/SkVariable/dataserie/${dataserieId}/${ isNullUndefinedOrEmpty(dataserieValueId) ? 0 : dataserieValueId }?serie_time=${serieTime}`, { headers: authHeaderJson() })    
};

const deleteDataserievalue = (dataserieValueId) => {
    return axios.delete(`/api/SkVariable/dataserievalue/${dataserieValueId}`, { headers: authHeaderJson() });
};

const updateBoardCompoenet = (boardComponent, componentId) => {
    return axios.put(`/api/Board/component/${componentId}`, boardComponent, { headers: authHeaderJson() });
};

const addListBoardElement = (boardId, boardElements) => {
    return axios({ method: 'post', url: `/api/Board/boardelement/${boardId}/list`, headers: authHeaderJson(), data : JSON.stringify(boardElements) })
};

const getListDataserieValueDocuments = (dataserievalueId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/skVariable/dataserievaluedocuments/${dataserievalueId}/list`, { headers: authHeaderJson() } );
};

const getListDataserieDocuments = (dataserieId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/skVariable/dataseriedocuments/${dataserieId}/list`, { headers: authHeaderJson() } );
};

const updateDataserieValueDocumentDeactivate = (documentId) => {
    //[##]PROBAR
    return axios.post(`/api/skVariable/dataserievaluedocumentdeactivate/${documentId}`, { headers: authHeaderJson() } )
};

const updateBoardElement = (boardElementId, boardElement) => {
    return axios.put(`/api/Board/boardelement/${boardElementId}`, boardElement, { headers: authHeaderJson() });
}

const deleteBoardElement = (boardElementId) => {
    return axios.delete(`/api/Board/boardelement/${boardElementId}`, { headers: authHeaderJson() });
}

const createBoard = (objBoard) => { 
    objBoard.id = 0;
    return axios({ method: 'post', url: `/api/Board/board`, headers: authHeaderJson(), data : JSON.stringify(objBoard) })
};

const setBoardContainerHtml = (boardId, containerList) => { 
    return axios.put(`/api/Board/boardcontainerhtml/${boardId}/list`, containerList, { headers: authHeaderJson() });
};

const saveBoard = (objBoard) => {
    return axios.put(`/api/Board/board/${objBoard.id}`, objBoard, { headers: authHeaderJson() });
};

const getBoardComponentInfoValues = (boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate) => {
    //[##PATH ROUTE##]
    let qs_periodEndsDate = periodEndsDate !== null ? `period_ends_date=${moment(periodEndsDate).format('MM/DD/YYYY')}` : '';
    let qs_periodStartDate = periodStartDate !== null ? `period_start_date=${moment(periodStartDate).format('MM/DD/YYYY')}` : '';

    let url = `/api/Board/boardelementcomponentinfo/${boardId}/${elementId}/${componentTypeId}/${isNullUndefinedOrEmpty(dataserieId) ? 0 : dataserieId}/${calendarSelectorId}/list`
 
    if(qs_periodStartDate !== '' )
    {
        url = url + '?' + qs_periodStartDate
    }
    if(qs_periodEndsDate !== '')
    {
        if(qs_periodStartDate != '' )
        {
            url = url + '&' + qs_periodEndsDate
        }
        else
        {
            url = url + '?' + qs_periodEndsDate		
        }
    }

    return axios.get(url, { headers: authHeaderJson() })    
};

const getUserPropsByBoard = (boardId, gapAnalyzeId, userName) => {
    //[##DEPRECATED##]
    let qs_boardId = boardId !== null ? `&board_id=${boardId}` : '';
    let qs_gapAnalyzeId = gapAnalyzeId !== null ? `&gap_analyze_id=${gapAnalyzeId}` : '';

    return axios.get(`/api/Board/usernameProps?username=${userName}${qs_boardId}${qs_gapAnalyzeId}`, { headers: authHeaderJson() } )
};

const createBoardStructure = (boardId, templateId) => {
    //[##PATH ROUTE##]
    return axios({ method: 'post', url: `/api/Board/boardstructure/${boardId}/${templateId}`, headers: authHeaderJson() })
};

const getBoardScopeElements = (scopeId, elementId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Board/boardscopeelements/${scopeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/list`, { headers: authHeaderJson() })    
};

const getBoardScopeValues = (boardId, elementId, calendarSelectorId, displayAggregationId, periodStartDate, periodEndsDate) => {
    //[##DEPRECATED##]
    let qs_boardId = boardId !== null ? `board_id=${boardId}` : '';
    let qs_elementId = elementId !== null ? `&element_id=${elementId}` : '';
    
    let qs_calendarSelectorId = calendarSelectorId !== null ? `&calendar_selector_id=${calendarSelectorId}` : '';
    let qs_displayAggregationId = displayAggregationId !== null ? `&display_aggregation_id=${displayAggregationId}` : '';
    let qs_periodStartDate = periodStartDate !== null ? `&period_start_date=${moment(periodStartDate).format('MM/DD/YYYY')}` : '';
    let qs_periodEndsDate = periodEndsDate !== null ? `&period_ends_date=${moment(periodEndsDate).format('MM/DD/YYYY')}` : '';

    return axios.get(`/api/Board/boardscopevalues/${boardId}/list?${qs_boardId}${qs_elementId}${qs_calendarSelectorId}${qs_displayAggregationId}${qs_periodStartDate}${qs_periodEndsDate}`, { headers: authHeaderJson() })    
};

const getBoardScopeDataseries = (scopeId, elementId) => {
    //[##DEPRECATED##]
    let qs_scopeId = scopeId !== null ? `scope_id=${scopeId}` : '';
    let qs_elementId = elementId !== null ? `&element_id=${elementId}` : '';

    return axios.get(`/api/Board/boardscopedataseries/${scopeId}/list?${qs_scopeId}${qs_elementId}`, { headers: authHeaderJson() })    
};

const updateBoardScope = (scopeId, objScope) => {
    return axios.put(`/api/Board/boardscope/${scopeId}`, objScope, { headers: authHeaderJson() });
};

const getListBoardScopes = (boardId) => {
    return axios.get(`/api/Board/boardscopes/${boardId}/list`, { headers: authHeaderJson() })    
};

const addListBoardScopes = (boardId, consolidationGroupList) => {
    //[##PATH ROUTE##]
    return axios.put(`/api/Board/boardscopes/${boardId}/list`, consolidationGroupList, { headers: authHeaderJson() })    
};

const getListBoardScopeDataseries = (scopeId, elementId, currentPeriodId) => {
    //[##PATH ROUTE##]
    let qs_periodId = currentPeriodId !== null ? `period_id=${moment(currentPeriodId).format('MM/DD/YYYY')}` : '';
    return axios.get(`/api/Board/boardscopedataseries/${scopeId}/${elementId}/list?${qs_periodId}`, { headers: authHeaderJson() })    
};

const addListBoardScopeDataseries = (scopeId, elementId, scopeDataserieList, currentPeriodId) => {
    //[##PATH ROUTE##]
    let qs_periodId = currentPeriodId !== null ? `period_id=${moment(currentPeriodId).format('MM/DD/YYYY')}` : '';
    return axios.put(`/api/Board/boardscopedataseries/${scopeId}/${elementId}/list?${qs_periodId}`, scopeDataserieList, { headers: authHeaderJson() });
};

const addBoardScope = (objScope) => { 
    objScope.id = 0;
    return axios({ method: 'post', url: `/api/Board/boardscope`, headers: authHeaderJson(), data : JSON.stringify(objScope) })
};

const setBoardComponentContainer = (boardId, containerId, l_item) => {
    //[##PATH ROUTE##]
    return axios.put(`/api/Board/boardcomponentcontainer/${boardId}/${containerId}/list`, l_item, { headers: authHeaderJson() });
};

const updateBoardContainerTitle = (containerId, title) => {
    //[##PATH ROUTE##]
    let qs_title = title !== null ? `?title=${title}` : '';
    return axios.put(`/api/Board/boardcontainertitle/${containerId}${qs_title}`, { headers: authHeaderJson() });
};

const getBoardComponentInfoRecursiveValues = (componentFilters, boardId, componentTypeId, elementId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate, displayAgregationId) => {
    //[##PATH ROUTE##]
    let qs_periodStartDate = periodStartDate !== null ? `period_start_date=${moment(periodStartDate).format('MM/DD/YYYY')}` : '';
    let qs_periodEndsDate = periodEndsDate !== null ? `period_ends_date=${moment(periodEndsDate).format('MM/DD/YYYY')}` : '';

    const aux_objFilters = {filter_type: componentFilters.filter_type, l_codes: componentFilters.l_codes};

    let url = `/api/Board/boardelementcomponentinforecursive/${boardId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/${isNullUndefinedOrEmpty(dataserieId) ? 0 : dataserieId}/${componentTypeId}/${calendarSelectorId}/${isNullUndefinedOrEmpty(displayAgregationId) ? 0 : displayAgregationId}/list`
 
    if(qs_periodStartDate !== '' )
    {
        url = url + '?' + qs_periodStartDate
    }
    if(qs_periodEndsDate !== '')
    {
        if(qs_periodStartDate != '' )
        {
            url = url + '&' + qs_periodEndsDate
        }
        else
        {
            url = url + '?' + qs_periodEndsDate		
        }
    }

    let config = {
        method: 'post',
        url: url,
        headers: authHeaderJson(),
        data : JSON.stringify(aux_objFilters)
    };

    return axios.request(config)
};

const getBoardComponentInfoRecursiveValuesPortfolio = (
    componentFilters,
    boardId,
    componentTypeId,
    elementId,
    dataserieId,
    calendarSelectorId,
    periodStartDate,
    periodEndsDate,
    displayAgregationId,
    signal = null
) => {
    let qs_periodStartDate = periodStartDate !== null
        ? `period_start_date=${moment(periodStartDate).format('MM/DD/YYYY')}`
        : '';

    let qs_periodEndsDate = periodEndsDate !== null
        ? `period_ends_date=${moment(periodEndsDate).format('MM/DD/YYYY')}`
        : '';

    const aux_objFilters = {
        filter_type: componentFilters.filter_type,
        l_codes: componentFilters.l_codes
    };

    let url = `/api/Board/boardelementcomponentinforecursive/${boardId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/${isNullUndefinedOrEmpty(dataserieId) ? 0 : dataserieId}/${componentTypeId}/${calendarSelectorId}/${isNullUndefinedOrEmpty(displayAgregationId) ? 0 : displayAgregationId}/list`

    if (qs_periodStartDate !== '') {
        url = url + '?' + qs_periodStartDate;
    }

    if (qs_periodEndsDate !== '') {
        if (qs_periodStartDate !== '') {
            url = url + '&' + qs_periodEndsDate;
        }
        else {
            url = url + '?' + qs_periodEndsDate;
        }
    }

    let config = {
        method: 'post',
        url: url,
        headers: authHeaderJson(),
        data: JSON.stringify(aux_objFilters)
    };

    if (signal) {
        config.signal = signal;
    }

    return axios.request(config);
};

const setBoardComponentComment = (elementId, boardComponentId, boardComponentInfoId, componentCommentId, comment, commentDate) => {
    //[##PATH ROUTE##]
    const objToSend = {
        board_component_id: boardComponentId,
        board_component_info_id: boardComponentInfoId,
        component_comment_id: componentCommentId,
        element_id: isNullUndefinedOrEmpty(elementId) ? 0 : parseInt(elementId),
        comment: comment,
        comment_date: moment(commentDate).format('MM/DD/YYYY')
    }

    return axios.post(`/api/Board/boardcomponentcomment`, objToSend, { headers: authHeaderJson() })    
};

const deleteBoardComponentComment = (componentCommentId) => {
    //[##PATH ROUTE##]
    return axios.delete(`/api/Board/boardcomponentcomment/${componentCommentId}`, { headers: authHeaderJson() });
};
const canTemplateCreation = (boardTypeId, elementId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Board/boardtemplate/${boardTypeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}/cancreate`, { headers: authHeaderJson() })    
};
const addBoardTemplate = (boardTypeId, boardTemplate, elementId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/Board/boardtemplate/${boardTypeId}/${isNullUndefinedOrEmpty(elementId) ? 0 : elementId}`, boardTemplate, { headers: authHeaderJson() })    
};
const getAdminTaskMonitoringKpiExport = async (elementId, calendarSelectorId, periodStartDate, periodEndsDate) => {
    const token = await requestExportToken("board/monitoringadvance/excel");
    let qs_periodStartDate = periodStartDate !== null ? `period_start_date=${moment(periodStartDate).format('MM/DD/YYYY')}` : '';
    let qs_periodEndsDate = periodEndsDate !== null ? `period_ends_date=${moment(periodEndsDate).format('MM/DD/YYYY')}` : '';

    let url = `/api/Board/board/monitoringadvance/excel/${elementId}/${calendarSelectorId}?exportToken=${token}`;

    if (qs_periodStartDate !== '') {
        url = url + '&' + qs_periodStartDate;
    }
    if (qs_periodEndsDate !== '') {
        url = url + '&' + qs_periodEndsDate;
    }

    return axios.get(url, { headers: authHeaderJson() });
};
const getLogroLimites = () => {
    //[##PATH ROUTE##]
    return axios.get(`/api/skVariable/logro/limites`, { headers: authHeaderJson() })
};


export {
    setBoardComponentContainer,
    createBoard,
    setBoardContainerHtml,
    getBoardComponentInfoValues,
    createBoardStructure,
    getBoardScopeElements,
    getBoardScopeValues,
    getBoardScopeDataseries,
    updateBoardScope,
    getListBoardScopes,
    addListBoardScopes,
    getListBoardScopeDataseries,
    addListBoardScopeDataseries,
    addBoardScope,
    saveBoard,
    getBoardById,
    getBoardStructure,
    getBoardStructureGeneric,
    getElementsByBoardId,
    getHomeBoardStadistic,
    getHomeBoardKpiGraph,
    getBoardConsolidations,
    updateBoardCompoenet,
    addListBoardElement,
    getListDataserieDocuments,
    getListDataserieValueDocuments,
    updateDataserieValueDocumentDeactivate,
    getElements,
    getBoardElementDataseries,
    deleteBoardElement,
    getBoardElementRoles,
    updateBoardElement,
    getBoardElementDataserieValue,
    getUserPropsByBoard,
    deleteDataserievalue,
    updateBoardContainerTitle,
    getBoardComponentInfoRecursiveValues,
    getBoardComponentInfoRecursiveValuesPortfolio,
    setBoardComponentComment,
    deleteBoardComponentComment,
    getAdminTaskMonitoringKpiExport,
    canTemplateCreation,
    addBoardTemplate,
    getLogroLimites
}